import { BookingAttempt } from 'types/BookingAttempt';

export interface BookingAttemptsState {
    loading: boolean;
    bookingAttempt?: BookingAttempt;
    status: BookingAttemptsStatus;
}

export enum BookingAttemptsStatus {
    Initial,
    Error,
    SaveStart,
    SaveSuccess
}
